<template>
  <td>
    <div class="custom-control custom-radio">
      <input
        @change="setActive()"
        v-bind:checked="content"
        :id="'rbc_' + this.model.id"
        name="rbc"
        class="custom-control-input"
        type="radio"
      />
      <label class="custom-control-label" :for="'rbc_' + this.model.id"></label>
    </div>
  </td>
</template>

<script lang="babel">
export default {
  props: {
    content: {
      required: true
    },
    model: {
      required: true
    }
  },
  methods: {
    async setActive() {
      await this.$http.post(`/api/v1/automaticMessageRule/setActive/` + this.model.id, {active: true});
    }
  }
};
</script>
